import { space } from '@sunwebgroup/ui-components'
import { Icon, IconGlyph, Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

interface ListItemProps extends React.HTMLAttributes<HTMLLIElement> {
  $icon?: IconGlyph
  $size?: number
}

const ListDescription = styled(Typography)`
 ${Typography.modVariant('body-s-regular-tight')};
`

export const Item = styled.li.attrs<ListItemProps>(({ $icon, $size, children }) => ({
  children: (
    <>
      <Icon glyph={$icon || 'CheckMarkSmall'} aria-hidden size={$size} />
      <ListDescription>{children}</ListDescription>
    </>
  ),
}))`
  list-style-type: none;

  ${Icon} {
    margin-right: ${space('primitives_space_4')};
    vertical-align: bottom;
  }
`

export const Root = styled.ul`
  padding: 0;
  margin: 0;
`
